<script>
    import { getContext } from "svelte";
    import {
        Button,
        Card,
        Col,
        Container,
        FormGroup,
        Modal,
        ModalBody,
        ModalFooter,
        ModalHeader,
        Row,
    } from "sveltestrap";

    import Cropper from 'svelte-easy-crop';
	import getCroppedImg from "../canvasUtil";

    import axios from "axios";
    import { token } from "../store"
    
    import { useQuery, useMutation  } from '@sveltestack/svelte-query'
    const profilData = useQuery("profilData");
    
    import Swal from 'sweetalert2';
    import { _ } from "svelte-i18n";
    
    import {flip} from "svelte/animate";
    import {dndzone} from "svelte-dnd-action";

    export let openModalPhoto, toggleModalPhoto;
    
    let apiUrl = getContext("apiUrl");
    let postURL = apiUrl + "ProfilAddPhoto.php?token=" + $token;

    let result;

    let mutation = useMutation(val => axios.post(postURL, val), {
        onSuccess: (data) => {
            result = data.data

            if(!$profilData.data.profil_photo) {
                $profilData.data.profil_photo = val.data;
            }

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                iconColor: 'white',
                customClass: {
                popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true
            })

            if(result.success){
                window.navigator.vibrate(200);
                Toast.fire({
                    icon: 'success',
                    title: result.success
                })
            }

            if(result.error){
                Toast.fire({
                    icon: 'error',
                    title: result.error
                })
            }
        }
    });

    let image,  pixelCrop, croppedImage;
    let crop = { x: 0, y: 0 }
    let cropSize = {
        width: 500,
        height: 500,
    };
    let zoom = 1;
    let openCropModal = false;
    const toggleCropModal = () => (openCropModal = !openCropModal);

    function onFileSelected(e) {
        toggleModalPhoto()
        toggleCropModal()

        let imageFile = e.target.files[0];
	    let reader = new FileReader();
        reader.onload = e => {
            image = e.target.result;
        };
        reader.readAsDataURL(imageFile);
	}

	function previewCrop(e) {
	  pixelCrop = e.detail.pixels;
    }
    
    const flipDurationMs = 300;

    let items = $profilData.data.photos

    function handler(e) {
        items = e.detail.items;
    }

    const orderMutation = useMutation(newOrder => axios.post(apiUrl + "ProfilChangePhotoOrder.php?token=" + $token, newOrder), {
        onSuccess: (data) => {
            result = data.data;

            if(result.success){
                window.navigator.vibrate(200);
            }
        }
    })

    function finalizeHandler(e) {
        let newOrder = [];
        
        items = e.detail.items;

        items.forEach(function(item, index) {
            console.log(item.id)
            newOrder.push({"id": item.id, "order": index});
        });

        $orderMutation.mutate(newOrder);
    }
</script>

<style>
    .photo {
        width: 220px;
		margin: 0.2em;
		padding: 0.3em;
    }
</style>

<Modal isOpen={openModalPhoto} toggle={toggleModalPhoto} backdrop={true} header="Photos"  size="lg">
    <ModalBody>
        <!-- ANCHOR Add Photo Form -->
        {#if items.length < 7}
            <form class="row row-cols-lg-auto g-3 align-items-center">
                <Col lg="12">
                    <FormGroup>
                        <input type="file" name="photo" on:change={(e) => { onFileSelected(e) }} class="form-control" />
                    </FormGroup>
                </Col>
            </form>
        {/if}
        <!-- ANCHOR Drag and Drop section -->
        {#if items}
            {#if items.length < 7}
                <hr />
            {/if}
            <Container>
                <div use:dndzone="{{items: items, flipDurationMs}}" on:consider="{handler}" on:finalize="{finalizeHandler}">
                    {#each items as photo(photo.id)}
                        <img src={photo.data} alt={$profilData.data.name} class="photo" animate:flip={{duration:flipDurationMs}}>
                    {/each}
                </div>
            </Container>
        {/if}
    </ModalBody>
    <ModalFooter>
        <Button color="secondary" on:click={toggleModalPhoto}>Fermer la fenêtre</Button>
    </ModalFooter>
</Modal>
<Modal isOpen={openCropModal} toggle={toggleCropModal} fullscreen={true}>
    <ModalBody>
        <Row>
            <Col lg="12">
                <Cropper 
                    {image}
                    bind:crop
                    bind:zoom
                    on:cropcomplete={previewCrop}
                    {cropSize}
                    width="100%"
                    height="100%"
                />
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button color="primary" on:click={
            async () => {
                croppedImage = await getCroppedImg(image, pixelCrop).then((e) => {
                    toggleCropModal()
                    $mutation.mutate({"img": e})
                })
            }
        }>Ajouter l'image</Button>
        <Button color="secondary" on:click={toggleCropModal}>Cancel</Button>
    </ModalFooter>
</Modal>